import React, { FC, useMemo } from 'react';
import { SearchResult } from '../../store/search';
import { FormattedMessage } from 'react-intl';
import { cn } from '../../helpers/classnames';

interface ResultColumnHederProps {
  type: SearchResult['type'];
  empty: boolean;
}

const headerColor: Partial<Record<SearchResult['type'], string>> = {
  workorder: 'bg-workorder-500 text-contrast-workorder',
  entityGroup: 'bg-primary-500 text-contrast-primary',
};

const ResultColumnHeader: FC<ResultColumnHederProps> = ({ type, empty }) => {
  const title = useMemo(() => {
    switch (type) {
      case 'contractor':
        return (
          <FormattedMessage
            id="search.column.contractor"
            defaultMessage="Contractor"
          />
        );
      case 'filterSet':
        return (
          <FormattedMessage
            id="search.column.filter_set"
            defaultMessage="Filter set"
          />
        );
      case 'entityGroup':
        return (
          <FormattedMessage
            id="search.column.entity_group"
            defaultMessage="Station"
          />
        );
      case 'workorder':
        return (
          <FormattedMessage
            id="search.column.workorder"
            defaultMessage="Workorder"
          />
        );
      default:
        return null;
    }
  }, [type]);

  return (
    <div className="cursor-default rounded-t bg-transparent">
      <p
        className={cn(
          'px-2 text-sm font-semibold leading-6',
          headerColor[type] ?? 'bg-background-400 text-text-950',
        )}
      >
        {title}
      </p>
      {empty && (
        <i className="text-text-800">
          <FormattedMessage
            id="search.no_matches_of_type"
            defaultMessage="No matches of this type"
          />
        </i>
      )}
    </div>
  );
};

export default ResultColumnHeader;
